import { GoogleCallbackComponent } from './modules/scheduler/modules/organizations/modules/organization/modules/business-settings/components/sync-calendars/google-callback/google-callback.component';
import { RenderMode } from '@angular/ssr';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { isUserLoggedInGuard } from './shared/services/guards/is-user-logged-in/is-user-logged-in.guard';
import { TermsComponent } from './components/terms/terms.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { AboutComponent } from './about/about.component';
import { ZoomSuccessComponent } from './modules/scheduler/modules/organizations/modules/organization/modules/business-settings/components/integrations/components/zoom-success/zoom-success.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { BlogsComponent } from './components/blogs/blogs.component';
import { BlogComponent } from './components/blogs/components/blog/blog.component';
import { FeaturesComponent } from './features/features.component';
import { ClientRedirectComponent } from './components/client-redirect/client-redirect.component';
import { HealthCareComponent } from './health-care/health-care.component';
import { BeautySalonBookingComponent } from './beauty-salon-booking/beauty-salon-booking.component';

export const routes: Routes = [
  {
    path: 'app',
    canActivate: [isUserLoggedInGuard],
    loadChildren: () =>
      import('./modules/scheduler/scheduler.module').then(
        (m) => m.SchedulerModule,
      ),
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'healthcare-scheduling-software',
    component: HealthCareComponent,
  },
  {
    path: 'beauty-salon-booking',
    component: BeautySalonBookingComponent,
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'client-bookings',
    component: ClientRedirectComponent,
  },
  {
    path: 'zoom',
    component: ZoomSuccessComponent,
    canActivate: [isUserLoggedInGuard],
  },

  {
    path: 'google/callback',
    component: GoogleCallbackComponent,
    canActivate: [isUserLoggedInGuard],
  },
  {
    path: 'about-us',
    component: AboutComponent,
  },
  {
    path: 'terms-of-service',
    component: TermsComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  {
    path: 'blogs',
    component: BlogsComponent,
  },
  {
    path: 'blogs/:slug',
    component: BlogComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
  },
  {
    path: 'features',
    component: FeaturesComponent,
  },
  {
    path: 'documentation',
    component: DocumentationComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error-pages',
    loadChildren: () =>
      import('./modules/error-pages/error-pages.module').then(
        (m) => m.ErrorPagesModule,
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,

      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
